"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function CloseIcon() {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16" },
        React.createElement("defs", null,
            React.createElement("path", { id: "close_a", d: "M12.067.5L13.5 1.933 8.433 7l5.067 5.068-1.433 1.433L7 8.433 1.933 13.5.5 12.067 5.566 7 .5 1.933 1.933.5 7 5.566 12.067.5z" })),
        React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(1 1)" },
            React.createElement("mask", { id: "close_b", fill: "#ffffff" },
                React.createElement("use", { xlinkHref: "#close_a" })),
            React.createElement("use", { fill: "#2F3535", fillRule: "nonzero", xlinkHref: "#close_a" }),
            React.createElement("g", { fill: "#FFFFFF", mask: "url(#close_b)" },
                React.createElement("path", { d: "M0 0H16V16H0z", transform: "translate(-1 -1)" })))));
}
exports.CloseIcon = CloseIcon;
